import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Утилита для объединения CSS классов
 * Объединяет clsx (для условных классов) и tailwind-merge (для разрешения конфликтов Tailwind)
 * 
 * @param {...any} inputs - Классы для объединения
 * @returns {string} - Объединенная строка классов
 * 
 * @example
 * cn('base-class', condition && 'conditional-class', 'another-class')
 * cn('px-4 py-2', 'px-6') // -> 'px-6 py-2' (px-6 переопределит px-4)
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export default cn;